import { motion } from "framer-motion"
import { useLanguage } from "../contexts/LanguageContext"

const TableViewComponent = ({ darkMode, filteredProducts, getStatusColor, getConfidenceColor, getProgressBarColor, getSalesIndicator, getStockIndicator, tableBorder, tableHeaderBg, tableRowBg }) => {
  const { t } = useLanguage()

  const thCls = `p-4 font-medium text-sm `

  const priceColorCls = (price) =>
    price === "high"   ? darkMode ? "bg-yellow-500/20 text-yellow-400" : "bg-yellow-100 text-yellow-800"
    : price === "medium" ? darkMode ? "bg-blue-500/20 text-blue-400"   : "bg-blue-100 text-blue-800"
                         : darkMode ? "bg-green-500/20 text-green-400"  : "bg-green-100 text-green-800"

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className={`overflow-x-auto rounded-xl border ${tableBorder}`} >
      <table className="w-full">
        <thead className={tableHeaderBg}>
          <tr>
            <th className={thCls}>{t("col_product")}</th>
            <th className={thCls}>{t("col_status")}</th>
            <th className={thCls}>{t("sales_label")}</th>
            <th className={thCls}>{t("stock_label")}</th>
            <th className={thCls}>{t("price_label")}</th>
            <th className={thCls}>{t("analysis")}</th>
            <th className={thCls}>{t("recommended_action")}</th>
            <th className={thCls}>{t("confidence")}</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts?.map((product, index) => {
            const salesIndicator = getSalesIndicator(product.sales)
            const stockIndicator = getStockIndicator(product.stock)

            return (
              <motion.tr key={product.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.05 }}
                className={`${tableRowBg} ${index % 2 === 0 ? "" : darkMode ? "bg-gray-800/20" : "bg-gray-100/30"} border-b ${tableBorder}`}>
                <td className="p-4 font-medium">{product.name}</td>
                <td className="p-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(product.status)} border`}>
                    {t(`status_${product.status?.toLowerCase()}`)}
                  </span>
                </td>
                <td className="p-4">
                  <div className={`flex items-center gap-2 `}>
                    <span className="font-bold">{product.sales}</span>
                    <div className={salesIndicator.color}>{salesIndicator.icon}</div>
                  </div>
                </td>
                <td className="p-4">
                  <div className={`flex items-center gap-2 `}>
                    <span className="font-bold">{product.stock}</span>
                    <div className={stockIndicator.color}>{stockIndicator.icon}</div>
                  </div>
                </td>
                <td className="p-4">
                  <span className={`px-3 py-1 rounded text-xs font-medium ${priceColorCls(product.price)}`}>
                    {t(`price_${product.price}`) || product.price}
                  </span>
                </td>
                <td className="p-4 max-w-xs">
                  <p className={`text-sm ${darkMode ? "text-gray-300" : "text-gray-700"}`}>{t(product.reasonKey) || product.reason}</p>
                </td>
                <td className="p-4">
                  <p className={`text-sm font-medium ${darkMode ? "text-blue-300" : "text-blue-600"}`}>{t(product.actionKey) || product.action}</p>
                </td>
                <td className="p-4">
                  <div className="flex flex-col gap-1">
                    <span className={`text-sm font-medium ${getConfidenceColor(product.confidence)}`}>{product.confidence}%</span>
                    <div className={`h-1 w-24 ${darkMode ? "bg-gray-700" : "bg-gray-200"} rounded-full overflow-hidden`}>
                      <motion.div initial={{ width: 0 }} animate={{ width: `${product.confidence}%` }} transition={{ duration: 1 }}
                        className={`h-full ${getProgressBarColor(product.confidence)}`} />
                    </div>
                  </div>
                </td>
              </motion.tr>
            )
          })}
        </tbody>
      </table>
    </motion.div>
  )
}

export default TableViewComponent
